import { render, staticRenderFns } from "./OrganismTicketTopicManagement.vue?vue&type=template&id=7c8ee4ae&scoped=true&"
import script from "./OrganismTicketTopicManagement.vue?vue&type=script&lang=js&"
export * from "./OrganismTicketTopicManagement.vue?vue&type=script&lang=js&"
import style0 from "./OrganismTicketTopicManagement.vue?vue&type=style&index=0&id=7c8ee4ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c8ee4ae",
  null
  
)

export default component.exports